import log from '../../log';

// this code executes before an instance is created. @servicenow/ui-internal/sandbox currently relies on host and dispatch.
// refactoring @servicenow/ui-internal/sandbox to support this single use case - all other user code is executed after an
// instance is created - didn't seem worth it. Even if we move to a lazy configuration initialization in the constructor
// dispatch won't be created until connectedCallback is executed.
function sandbox(fn, options, message) {
	try {
		return fn(options);
	} catch (error) {
		log(message, {origin: 'sandbox', host: options ? options.host : null});
		return {};
	}
}

export function mergeBehaviorInitialState(
	behaviors,
	componentInitialState,
	componentSetInitialState,
	tagName
) {
	const behaviorState = {};
	const {length: behaviorsCount} = behaviors;

	for (let i = 0; i < behaviorsCount; i++) {
		const {
			name,
			options,
			behavior: {initialState: behaviorInitialState, options: behaviorOptions}
		} = behaviors[i];
		behaviorState[name] =
			typeof behaviorInitialState === 'function'
				? sandbox(
						behaviorInitialState,
						options || behaviorOptions,
						`The initialState function for the ${name} behavior threw an error when defining <${tagName} />`
				  )
				: behaviorInitialState;
	}

	function setInitialState({host, properties}) {
		const behaviorStateDynamic = behaviorState;
		for (let i = 0; i < behaviorsCount; i++) {
			const {
				name,
				options,
				behavior: {setInitialState: behaviorSetInitialState, options: behaviorOptions}
			} = behaviors[i];

			if (typeof behaviorSetInitialState === 'function') {
				behaviorStateDynamic[name] = {
					...behaviorState[name],
					...sandbox(
						behaviorSetInitialState,
						{host, properties, options: options || behaviorOptions},
						`The setInitialState function for the ${name} behavior threw an error when defining <${tagName} />`
					)
				};
			}
		}

		return {
			...(Object.keys(behaviorStateDynamic).length ? {behaviors: behaviorStateDynamic} : {}),
			...(typeof componentSetInitialState === 'function' &&
				sandbox(
					componentSetInitialState,
					{host, properties},
					`The setInitialState function for ${tagName} threw an error`
				))
		};
	}

	const initialState = {
		...(Object.keys(behaviorState).length ? {behaviors: behaviorState} : {}),
		...componentInitialState
	};

	return {
		initialState,
		setInitialState
	};
}
